import { SegmentedControl } from "@src/appV2/redesign/components/SegmentedControl";

import { ShiftStatusFilter, type ShiftStatusFilterType } from "../types";

interface GuidedSupportTabsProps {
  readonly statusFilter: ShiftStatusFilterType;
  readonly onStatusFilterChange: (status: ShiftStatusFilterType) => void;
  readonly upcomingCount?: number;
  readonly pastCount?: number;
}

export function GuidedSupportTabs(props: GuidedSupportTabsProps) {
  const { statusFilter, onStatusFilterChange, upcomingCount = 0, pastCount = 0 } = props;

  return (
    <SegmentedControl
      ariaLabel="Filter shifts by status"
      value={statusFilter}
      options={[
        { label: "Past shifts", value: ShiftStatusFilter.PAST, count: pastCount },
        { label: "Upcoming shifts", value: ShiftStatusFilter.UPCOMING, count: upcomingCount },
      ]}
      sx={(theme) => ({ marginY: theme.spacing(4) })}
      onChange={(status) => {
        onStatusFilterChange(status);
      }}
    />
  );
}
